/**
 * Eén callsheetveld opslaan (PATCH) en pas daarna — alleen bij succes — de correctie melden
 * (leren van correcties, wiki-feedback 26 sep). Een mislukte opslag mag nooit als correctie
 * in iemands AI-voorbeelden belanden.
 */
export async function slaVeldOp({ fetcher, url, veld, waarde, naSucces }) {
  const r = await fetcher(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ [veld]: waarde }),
  });
  if (!r?.ok) throw new Error(`Opslaan mislukt (HTTP ${r?.status ?? '?'})`);
  naSucces?.();
  return r;
}
